export default __webpack_public_path__ + "static/media/rewards.1a7ac926.png";